import {AxiosRequestConfig} from 'axios';

import request from '../../axios';

const getInputUnits = async (props: IInputUnitsProps) => {
  const {data}: {data: IInputUnits} = await request.get(
    `api/v2/store/input-units`,
    {
      params: props,
    } as AxiosRequestConfig,
  );
  return data;
};

export default getInputUnits;
